import { css, Theme } from "@emotion/react";

export const typographyStyles = (theme: Theme) =>
    css({
        body: {
            fontFamily: theme.candy.typography.fontFamily.regular,
        },
        ".candy-container": {
            ...theme.candy.typography.primary.css(),
        },
    });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const globalStyles: any = (theme: Theme) =>
    css({
        html: {
            height: "100%",
            margin: 0,
            padding: 0,
        },

        body: {
            height: "100%",
            margin: 0,
            padding: 0,
            backgroundColor: theme.candy.keyPalette.panelBackgroundColor,
        },

        ".candy-container": {
            position: "relative",
            webkitFontSmoothing: "antialiased",
            colorScheme: theme.candy.rootColorScheme,
            color: theme.candy.typography.primary.color,
        },

        ".candy-page-caption": {
            fontSize: "20px",
            color: theme.candy.typography.primary.color,
            lineHeight: "34px",
            marginBottom: 10,
            minJeight: 34,
            width: "75%",
        },

        ".candy-page-caption-title": {
            paddingTop: 20,
        },

        ".candy-table": {
            tableLayout: "fixed",
            width: 0,
            borderCollapse: "collapse",
            borderWidth: 0,
            borderColor: theme.candy.border.color,
        },

        ".candy-table-ion": {
            td: {
                paddingTop: "10px !important",
            },
        },

        "td.candy-td-head": {
            ...theme.candy.tables.headers.smallFont.css(),
            padding: "10px 5px",
            letterSpacing: "0.005em",
            verticalAlign: "bottom",
        },

        ".candy-tr-head": {
            borderBottom: theme.candy.tables.border.solid,
        },

        ".candy-tr-border-bottom": {
            borderBottom: theme.candy.tables.border.solid,
        },

        ".candy-td-number": {
            color: theme.candy.tables.headers.smallFont.color,
            textAlign: "center",
        },

        ".title-col-bottom": {
            marginBottom: 20,
        },

        ".candy-title-signer": {
            marginTop: 40,
        },

        "#pageContent": {
            margin: 0,
            padding: 0,
            position: "relative",
            minHeight: "100%",
            WebkitFontSmoothing: "antialiased",
        },
    });

export const fontStyle = () => css`
    @font-face {
        font-family: "Lab Grotesque";
        font-style: normal;
        font-weight: 100;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Thin.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Thin.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: normal;
        font-weight: 300;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Light.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Light.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: normal;
        font-weight: 400;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Regular.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Regular.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: normal;
        font-weight: 500;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Medium.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Medium.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: normal;
        font-weight: 600;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Medium.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Medium.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: normal;
        font-weight: 700;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Bold.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Bold.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: italic;
        font-weight: 100;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-ThinItalic.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-ThinItalic.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: italic;
        font-weight: 300;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-LightItalic.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-LightItalic.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: italic;
        font-weight: 400;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Italic.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-Italic.woff) format("woff");
    }

    @font-face {
        font-family: "Lab Grotesque";
        font-style: italic;
        font-weight: 700;
        src:
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-BoldItalic.woff2) format("woff2"),
            url(https://s.kontur.ru/common-v2/fonts/LabGrotesque/LabGrotesque-BoldItalic.woff) format("woff");
    }
`;
